export const SUBSCRIPTION_STATUSES = {
  TRIAL: 'trial',
  SUSPENDED: 'suspended',
  ACTIVE: 'active',
};
